import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SitesService } from 'src/app/sites/sites.service';
import { DeviceFactory } from '../../../device-factory/device-factory';
import { DomainsService } from 'src/app/shared/services/domains.service';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { SiteDashboardService } from 'src/app/home/site-dashboard/site-dashboard.service';

@Component({
	selector: 'app-iotah-utilization-report',
	templateUrl: './iotah-utilization-report.component.html',
	styleUrls: ['./iotah-utilization-report.component.css']
})
export class IotahUtilizationReportComponent implements OnInit, OnDestroy {
	@ViewChild('printModal') printModal: any;
	@ViewChild('hiddenPrintBtn') hiddenPrintBtn: ElementRef;
	siteId: number;
	data: any = null;
	devices: any = {};
	trucksReportData: any = null;
	trucks: any = {};
	totalTrucks: any = [];
	totalTrucksPdf: any = [];
	siteSub: Subscription = new Subscription();
	isPrintModalOpen = false;
	siteInfo: any;
	periods = [
		{ value: 'last_7_days', label: this.translateService.instant('durations.last_7_days') },
		{ value: 'last_14_days', label: this.translateService.instant('durations.last_14_days') },
		{ value: 'last_30_days', label: this.translateService.instant('durations.last_30_days') },
		{ value: 'last_90_days', label: this.translateService.instant('durations.last_90_days') },
		{ value: 'year_to_date', label: this.translateService.instant('durations.year_to_date') },
		{ value: 'last_year', label: this.translateService.instant('durations.last_year') },
		{ value: 'since_installation', label: this.translateService.instant('durations.all_years') },
	];
	selectedReportPeriod = this.periods[0].value;

	daysFilters = [
		{ value: 'allDays', label: this.translateService.instant('g.all_days') },
		{ value: 'workingDays', label: this.translateService.instant('g.working_days') },
	];
	selectedReportDaysFilter = this.daysFilters[0].value;

	siteInstallationDate: Date = new Date(0);

	truckTypes = [];
	selectedTruckType = "All";
	truckManufacturer = [];
	selectedtruckManufacturer = "All";
	vintageOptionsDropdown = this.siteDashboardService.vintageOptionsDropdown; 
	selectedBatteryVintage = [this.siteDashboardService.vintageOptionsDropdown[0].value];
	selectedBatteryVintageForScores = [this.siteDashboardService.vintageOptionsDropdown[0].value];

	selectedPeriod = this.periods[0].value;
	selectedPeriodFormatted: string = '';
	selectedDaysFilter = this.daysFilters[0].value;

	toDate = moment().subtract(1, 'day').endOf('day').toDate();

	maxDate = moment().subtract(1, 'day').endOf('day').toDate();

	fromDate = moment(this.toDate).subtract(29, 'days').startOf('day').toDate();

	truckTypesDailyFleet = [];
	selectedTruckTypeDailyFleet = "All";

	truckManufacturerDailyFleet = [];
	selectedTruckManufacturerDailyFleet = "All";

	constructor(
		private sitesService: SitesService,
		private route: ActivatedRoute,	
		private sideMenuService: SideMenuService,
		private commonService: CommonService,
		private translateService: TranslateService,
		private siteDashboardService: SiteDashboardService,
	) {}

	onSelectionChanged(event) {
		switch (event.filter) {
			case 'period':
				this.selectedPeriod = event.value;
				break;
			case 'truckType':
				this.selectedTruckType = event.value;
				break;
			case 'daysFilter':
				this.selectedDaysFilter = event.value;
				break;
			case 'selectedTruckTypeDailyFleet':
				this.selectedTruckTypeDailyFleet = event.value;
				break;
			case 'selectedTruckManufacturerDailyFleet':
				this.selectedTruckManufacturerDailyFleet = event.value;
				break;
			case 'truckManufacturer':
				this.selectedtruckManufacturer = event.value;
				break;
			default:
				break;
		}
		this.updateSelectedData(this.selectedPeriod, this.devices, '');
	}

	// For the first block of filters in the page
	prepareTruckTypes() {
		this.truckTypes = [{value: 'All', label: 'All'}];
		this.truckManufacturer = [{value: 'All', label: 'All'}];

		for (const macAddress in this.devices) {
			const device = this.devices[macAddress];

			if (device.truck_type) {
				const isExist = this.truckTypes.find((type) => type.value == device.truck_type);
				if (!isExist)
					this.truckTypes.push({
						value: device.truck_type,
						label: device.truck_type,
					});
			}
			if (device.truck_manufacturer) {
				const isExist = this.truckManufacturer.find((type) => type.value == device.truck_type);
				if (!isExist)
					this.truckManufacturer.push({
						value: device.truck_manufacturer,
						label: device.truck_manufacturer,
					});
			}
		}
	}

	ngOnInit() {
		this.siteSub = this.sideMenuService.currentSite.subscribe((siteInfo: any) => {
			if (siteInfo && siteInfo.installation_date) {
				this.siteInstallationDate = moment.utc(siteInfo.installation_date).startOf('day').toDate();

				if (this.siteInstallationDate > this.fromDate)
					this.fromDate = this.siteInstallationDate;
			}

			this.commonService.setPageTabTitle(`${siteInfo['customer_name']} - ${siteInfo['name']} - ${this.translateService.instant('g.iotah_site_utilization')}`);
			this.siteInfo = siteInfo; 
		});
		this.siteId = this.route.parent.snapshot.params.siteId || 0;
		this.sitesService.getUtilizationScoreData(this.siteId, [DeviceFactory.types.iotah], {relative_utilization_chart: true}).subscribe((res: any) => {
			this.data = res.data;
			this.devices = res.devices;
			this.updateSelectedData(this.selectedPeriod, this.devices, '');
			this.prepareTruckTypes();
		});

		this.sitesService.getUtilizationScoreDataTruckReport(this.siteId, [DeviceFactory.types.iotah], {relative_utilization_chart: true}).subscribe((res: any) => {
			this.trucksReportData = res.data;
			this.trucks = res.devices;
			this.updateSelectedData(this.selectedReportPeriod, this.trucks, 'pdf');
		});
	}

	// For the second block of filters in the page (For the children components filters)
	prepareParentFiltersOptions(event: { truckTypes: any[], truckManufacturers: any[] }) {
		if (event.truckTypes?.length) {
			this.truckTypesDailyFleet.push(...event.truckTypes);
			this.truckTypesDailyFleet = [...new Map(this.truckTypesDailyFleet.map(i => [i.value, i])).values()];
		}

		if (event.truckManufacturers?.length) {
			this.truckManufacturerDailyFleet.push(...event.truckManufacturers);
			this.truckManufacturerDailyFleet = [...new Map(this.truckManufacturerDailyFleet.map(i => [i.value, i])).values()];
		}
	}

	ngOnDestroy() {
		if (this.siteSub)
			this.siteSub.unsubscribe();
	}
	
	onSelectionReportChanged(event) {
		switch (event.filter) {
			case 'period':
				this.selectedReportPeriod = event.value;
				break;
			case 'daysFilter':
				this.selectedReportDaysFilter = event.value;
				break;
			default:
				break;
		}
		this.updateSelectedData(this.selectedReportPeriod, this.trucks, 'pdf');
	}

	updateSelectedData(selectedPeriod: string, devices: any, type: string) {
		const arrDevices =  Object.values(devices);
		this.formatPeriod(selectedPeriod, arrDevices, type);
	}

	openPrintModal() {
		this.printModal.show();
		this.isPrintModalOpen = true;
	}

	confirmPrint() {
		this.isPrintModalOpen = false;
		this.printModal.hide();
		setTimeout(() => {
			this.hiddenPrintBtn.nativeElement.click();
		}, 200);
	}

	formatPeriod(period: string, devices: any[], type: string) {
		const oldestTimestamp = Math.min(...devices.filter((d: any) => d.installation_date).map((d: any) => Number(d.installation_date)));
		const { from, to } = this.commonService.getDateRange(period, oldestTimestamp);
		this.selectedPeriodFormatted = `${moment(from).format('M/D/YYYY')} - ${moment(to).format('M/D/YYYY')}`;
		if(type == 'pdf')
			this.totalTrucksPdf = devices.filter(d => moment.unix(d.installation_date).isSameOrBefore(moment(to))).length;
		else
			this.totalTrucks = devices.filter(d => moment.unix(d.installation_date).isSameOrBefore(moment(to))).length;
	}

	batteryVintageSelectionChanged() {
		if (!this.selectedBatteryVintage.length)
			this.selectedBatteryVintage = [this.siteDashboardService.vintageOptionsDropdown[0].value];

		if (!this.selectedBatteryVintageForScores.length)
			this.selectedBatteryVintageForScores = [this.siteDashboardService.vintageOptionsDropdown[0].value];

		if (this.selectedBatteryVintage.length > 1 && this.selectedBatteryVintage.includes(this.siteDashboardService.vintageOptionsDropdown[0].value)) {
			if (this.selectedBatteryVintage[0] == this.siteDashboardService.vintageOptionsDropdown[0].value)
				this.selectedBatteryVintage = this.selectedBatteryVintage.filter(value => value !== this.siteDashboardService.vintageOptionsDropdown[0].value);
			else
				this.selectedBatteryVintage = [this.siteDashboardService.vintageOptionsDropdown[0].value];
		}

		if (this.selectedBatteryVintageForScores.length > 1 && this.selectedBatteryVintageForScores.includes(this.siteDashboardService.vintageOptionsDropdown[0].value)) {
			if (this.selectedBatteryVintageForScores[0] == this.siteDashboardService.vintageOptionsDropdown[0].value)
				this.selectedBatteryVintageForScores = this.selectedBatteryVintageForScores.filter(value => value !== this.siteDashboardService.vintageOptionsDropdown[0].value);
			else
				this.selectedBatteryVintageForScores = [this.siteDashboardService.vintageOptionsDropdown[0].value];
		}
	}
}
